import BaseElement from './BaseElement';
import PriceSlider from '../Components/PriceUserAmountSlider';
class PriceUserAmountSlider extends BaseElement {
    constructor() {
        super(...arguments);
        this.element = PriceSlider;
    }
}
export default PriceUserAmountSlider;
